import React from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { useMobile } from 'utils/media';
import { Dialog } from '@mui/material';
import Model from '../../../../../model';
import './index.sass';

const { block, el } = bem('pickup-info-modal');

const PickupInfoModal = () => {

    const { modal } = Model;
    const { isMobile } = useMobile();
    const { isPickupInfoOpen, closePickupInfo } = modal;

    const handleClose = () => {
        closePickupInfo();
    }

    return (
        <Dialog
            className={ block() }
            open={ isPickupInfoOpen }
            onClose={ handleClose }
            fullWidth={ true }
            fullScreen={ isMobile }
            maxWidth={ 'md' }
            scroll={ 'body' }
            PaperProps={ {
                sx: {
                    maxWidth: 1024,
                    margin: '0 auto',
                    width: 1024,
                    borderRadius: isMobile ? 0 : '20px'
                }
            } }
        >
            <div className={ el('content') }>
                <Text tag={ 'div' } >
                    Адрес: ул. 4-я Тверская-Ямская, д. 22 (ближайшая станция метро Маяковская)
                </Text>
                <Text tag={ 'div' } >
                    Как нас найти: Ориентир - салон красоты "Beauty Center". Слева от салона вы увидите черные
                    металлические ворота.
                    На воротах пульт. Нажмите 140 (или 99) и калитка откроется (услышите характерный сигнал открывания).
                    Идите направо
                    вдоль здания по указателям "Ответ" до крыльца с козырьком. На стене увидите вывеску "Ответ".
                    Заходите, вы на месте.
                </Text>
                <Text tag={ 'div' } >
                    У здания есть городская парковка 380 руб./час
                </Text>
                <Text tag={ 'div' } >
                    Груз выдается по номеру заказа.
                </Text>
            </div>
            <div className={el('header')}>
                <div className={el('close')} onClick={handleClose}><Icon name={'x'}/></div>
            </div>
        </Dialog>
    )
}

export default observer(PickupInfoModal);
